<template>
  <a-row
    :gutter="[16, 16]"
    :style="{ margin: '1rem 0' }">
    <template
      v-for="checkbox in baseCheckboxes"
      :key="checkbox.field">
      <a-col
        v-if="checkbox.condition === undefined || checkbox.condition"
        :style="{ paddingLeft: '0', paddingRight: '0.5rem' }">
        <a-checkbox
          v-model:checked="data[checkbox.field]"
          :disabled="disabled">
          {{ checkbox.label }}
        </a-checkbox>
      </a-col>
    </template>
    <template v-if="isNewPlanOptionsVisible">
      <template
        v-for="checkbox in newPlanOptions"
        :key="checkbox.field">
        <a-col :style="{ paddingLeft: '0', paddingRight: '0.5rem' }">
          <a-checkbox
            v-model:checked="data[checkbox.field]">
            {{ checkbox.label }}
          </a-checkbox>
        </a-col>
      </template>
    </template>
    <template v-if="isNewPlanOptionsVisible && userHasPermissionForNewOptions">
      <template
        v-for="checkbox in newPlanWithPermissionOptions"
        :key="checkbox.field">
        <a-col :style="{ paddingLeft: '0', paddingRight: '0.5rem' }">
          <a-checkbox
            v-model:checked="data[checkbox.field]">
            {{ checkbox.label }}
          </a-checkbox>
        </a-col>
      </template>
    </template>
  </a-row>
</template>

<script setup>

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  userHasPermissionForNewOptions: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    required: true,
  },
  isHasPanoramaCheckboxVisible: {
    type: Boolean,
    default: false,
  },
  isNewPlanOptionsVisible: {
    type: Boolean,
    default: false,
  },
});

const baseCheckboxes = [
  { field: 'type2d', label: '2D' },
  { field: 'type3d', label: '3D' },
  { field: 'hasPanorama', label: 'Панорама', condition: props.isHasPanoramaCheckboxVisible },
];

const newPlanOptions = [
  { field: 'isRulerEnabled', label: 'Линейка' },
  { field: 'isInteractiveTopViewEnabled', label: 'Интерактивный верхний вид' },
  { field: 'isTopViewAsMiniPlanEnabled', label: 'Верхний вид как мини-план' },
  { field: 'isHideOptionalFurnitureEnabled', label: 'Скрывать необязательную мебель' },
  { field: 'isTransparentTopViewEnabled', label: 'Прозрачный верхний вид' },
  { field: 'isWebpEnabled', label: 'WEBP' },
];

const newPlanWithPermissionOptions = [
  { field: 'isFurnitureLightsEnabled', label: 'Расстановка света' },
  { field: 'isFurnitureCurtainsRadiatorsEnabled', label: 'Расстановка штор и радиаторов' },
  { field: 'isFurnitureGlassWallsCollapseEnabled', label: 'Схлопывание балконных стен' },
  { field: 'isFurnitureEnabled', label: 'Расстановка мебели' },

  { field: 'isUnrealTopViewsCaptureEnabled', label: 'Съёмка сверху' },
  { field: 'isUnrealTopDownViewsCaptureEnabled', label: 'Съёмка сверху вокруг строения' },

  { field: 'isUnrealMiddleCutCaptureEnabled', label: 'Срединный срез' },
  { field: 'applyMiddleCutInTopView', label: 'Срединный срез (при съемке сверху)' },
];

</script>
